import React from 'react';
import './ControlPanel.css';

/**
 * ControlPanel 组件
 * 
 * 功能：
 * - 提供心跳速率控制滑块
 * - 实时显示当前心跳速率值
 * - 自动心率模式切换开关
 * - 爱心图标显示当前心跳动画
 * - 影响背景心形粒子的心跳动画速度
 * 
 * 参数范围：0-200 BPM
 * 默认值：72 BPM（正常心率）
 */

interface ControlPanelProps {
  heartRate: number; // 当前心跳速率
  onChange: (rate: number) => void; // 心跳速率变化回调
  autoMode: boolean; // 自动心率模式
  onAutoModeChange: (enabled: boolean) => void; // 自动模式切换回调
}

const ControlPanel: React.FC<ControlPanelProps> = ({ heartRate, onChange, autoMode, onAutoModeChange }) => {
  return (
    <div className="control-panel">
      <div className="control-content">
        {/* 爱心图标 */}
        <div className="control-heart" style={{ animationDuration: `${60 / heartRate}s` }}>
          ❤️
        </div>
        
        {/* 自动模式开关 */}
        <div className="control-switch">
          <label className="switch-label">
            <input
              type="checkbox"
              checked={autoMode}
              onChange={(e) => onAutoModeChange(e.target.checked)}
              className="switch-input"
            />
            <span className="switch-slider"></span>
            <span className="switch-text">自动</span>
          </label>
        </div>
        
        {/* 滑块 */}
        <div className="control-slider-container">
          <input
            type="range"
            min="0"
            max="200"
            value={heartRate}
            onChange={(e) => onChange(Number(e.target.value))}
            className="control-slider"
          />
        </div>
        
        {/* 心率数值显示 */}
        <div className="control-value">
          <span className="value-number">{heartRate}</span>
          <span className="value-unit">BPM</span>
        </div>
      </div>
    </div>
  );
};

export default ControlPanel;